export default function R_Plot() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Plot Component</h1>
      <p>This is the R_Plot tutorial section.</p>
    </div>
  );
}
